import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'vfs-button-icon-header',
  templateUrl: './button-icon-header.component.html',
  styleUrls: ['./button-icon-header.component.scss']
})
export class ButtonIconHeaderComponent {
  @Input() disabled: boolean;
  @Input() type: string;
  @Input() icon: string;
  @Output() buttonClick = new EventEmitter();

  onButtonClick(evt: Event) {
    if (!this.disabled) {
      this.buttonClick.emit(evt);
    }
  }
}
